import { DateTime } from 'luxon'; 
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { HttpService } from '../../services/http-service/http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../../services/auth-service/auth.service';
import { TranslationService } from '../../import/services/translation.service';

import { ADMINISTRATION, HOST, DATACENTER, IMPORT, INSPECTION} from '../../routes';

@Injectable()
export class DataAdministrationService {

	public returnUrl: string;
	public returnEntity: Object;
	public changedField: Object;
	public loadEntity = false;

  constructor(private authService: AuthService, private http: HttpService, private httpClient: HttpClient, private translationService: TranslationService) { }

  // create entity

  createEntity(host: string, subRoute: string, entity: Object, formFields) {
	if (host === undefined || host === null) host = 'administration';
	subRoute = this.getSubRoute(subRoute);
	const formData: FormData = new FormData();
	Object.keys(entity).forEach(function(key) {
		var parts = key.split(' - ');
		var formKey = key;
		if (parts.length > 1) {
			formKey = parts[0] + '[' + parts[parts.length - 1] + ']';
		}
		if (entity[key] !== undefined && entity[key] !== null && entity[key] !== 'null') {
			if (Array.isArray(entity[key])) {
				var i = 0;
				for (i = 0; i < entity[key].length; i++) {
					var value = entity[key][i];
					if (typeof value === 'object' && value !== null && value['value'] !== undefined) {
						formData.append(formKey + '[' + i + ']', value['value']);
					} else {
						formData.append(formKey + '[' + i + ']', value);
					}
				}
			} else {
				const results = formFields.filter(formField => formField['snake_case'] == key && formField['file'] == true && formField['upload_download'] === 'upload');
				const field = formFields.filter(formField => formField['snake_case'] == key)[0];
				if (field && field['data_type'] === 'datetime') {
					if (entity[key] !== null) {
						var date = DateTime.fromISO(entity[key]).toString();
						formData.append(formKey, date);
					}
				} else if (results.length === 0) formData.append(formKey, entity[key]);
			}
		}
	});

    return this.http.post(this.getHost(host) + '/' + subRoute, formData);
  }

  handleFile(host: string, subRoute: string, id: string, snakeCase: string, internalFieldName: string, value) {
	if (host === undefined || host === null) host = 'administration';
	subRoute = this.getSubRoute(subRoute);
	var route = this.getHost(host) + '/' + subRoute + '/' + id + '/' + internalFieldName;
	if (value instanceof File) {
		const formData: FormData = new FormData();
		formData.append(snakeCase, value);
		return this.http.post(route, formData);
	} else if (!value) {
		return this.http.delete(route);
	}

	return new Observable();
  }

  getForm(entityType: string, method: string, objectId: string) {
	  entityType = this.translationService.convertEntityType(entityType);
	  var url = IMPORT + '/entities/form?entity_type=' + entityType + '&method=' + method;
	  if (objectId) url += '&object_id=' + objectId;

	  return this.http.get(url);
  }

  // load candidates

  loadAllCandidates(entityType: string, fieldName: string, hostEntityType: string = null) {
	entityType = this.translationService.convertEntityType(entityType);
	var hostEntity = '';
	if (hostEntityType !== null) hostEntity = '&host_entity_type=' + this.translationService.convertEntityType(hostEntityType);
    return this.http.get(IMPORT + '/entities/candidates?entity_type=' + entityType + '&field_name=' + fieldName + hostEntity);
  }

  loadAdmins() {
	  return this.http.get(ADMINISTRATION + '/users/admins');
  }

  sendDeleteRequest(entityType: string, entity: Object, receiverId: string, message: string) {
	const formData: FormData = new FormData();
	formData.append('entity_type', entityType);
	formData.append('entity_id', entity['id']);
	formData.append('receiver_id', receiverId);
	if (message) formData.append('message', message);
	return this.http.post(ADMINISTRATION + '/users/requestdelete', formData);
  }

  getReferencedEntities(id: string, entityType: string) {
	  return this.http.get(IMPORT + '/entities/referencedentities?id=' + id + '&entity_type=' + entityType);
  }

  // get entity

  getEntity(host: string, subRoute: string, entityId: string) {
	return this.http.get(this.getHost(host) + '/' + this.getSubRoute(subRoute) + '/' + entityId);
  }

  // get entities

  getEntities(host: string, subRoute: string, params: HttpParams): Observable<any> {
	  return this.httpClient.get<HttpResponse<any>>(this.getHost(host) + '/' + subRoute , { params: params, observe: 'response'});
  }

  // update entity

  updateEntity(host: string, subRoute: string, entity: Object, formFields): Observable<Object> {
	if (host === undefined || host === null) host = 'administration';
	var request = {};
	subRoute = this.getSubRoute(subRoute);
	Object.keys(entity).forEach(function(key) {
		const field = formFields.filter(formField => formField['snake_case'] === key)[0];
		const results = formFields.filter(formField => formField['snake_case'] === key && formField['file'] === true && formField['upload_download'] === 'upload');

		var parts = key.split(' - ');
		var formKey = key;
		var hostKey1 = null;
		var hostKey2 = null;
		var hostKey3 = null;
		if (parts.length > 1) {
			hostKey1 = parts[0];
			formKey = parts[parts.length - 1];
			if (!request[hostKey1]) request[hostKey1] = {};
			if (parts.length > 2) {
				hostKey2 = parts[1];
				if (!request[hostKey1][hostKey2]) request[hostKey1][hostKey2] = {};
			}
			if (parts.length > 3) {
				hostKey3 = parts[2];
				if (!request[hostKey1][hostKey2][hostKey3]) request[hostKey1][hostKey2][hostKey3] = {};
			}
		}
		
		if (key !== 'id' && results.length === 0) {
			if (entity[key] === null || entity[key] === 'null' || entity[key] === undefined) {
				if (hostKey3 !== null) request[hostKey1][hostKey2][hostKey3][formKey] = null;
				else if (hostKey2 !== null) request[hostKey1][hostKey2][formKey] = null;
				else if (hostKey1 !== null) request[hostKey1][formKey] = null;
				else request[formKey] = null;
			} else if (Array.isArray(entity[key])) {
				if (hostKey3 !== null) request[hostKey1][hostKey2][hostKey3][formKey] = [];
				else if (hostKey2 !== null) request[hostKey1][hostKey2][formKey] = [];
				else if (hostKey1 !== null) request[hostKey1][formKey] = [];
				else request[formKey] = [];
				var i = 0;
				for (i = 0; i < entity[key].length; i++) {
					var value = entity[key][i];
					if (typeof value === 'object' && value !== null && value['value'] !== undefined) {
						if (hostKey3 !== null) request[hostKey1][hostKey2][hostKey3][formKey].push(value['value']);
						else if (hostKey2 !== null) request[hostKey1][hostKey2][formKey].push(value['value']);
						else if (hostKey1 !== null) request[hostKey1][formKey].push(value['value']);
						else request[formKey].push(value['value']);
					} else {
						if (hostKey3 !== null) request[hostKey1][hostKey2][hostKey3][formKey].push(value);
						else if (hostKey2 !== null) request[hostKey1][hostKey2][formKey].push(value);
						else if (hostKey1 !== null) request[hostKey1][formKey].push(value);
						else request[formKey].push(value);
					}
				}
			} else {
				if (field && field['data_type'] === 'datetime' && field['data_type'] !== null) {
					if (entity[key] !== null && entity[key] !== '') {
						var date = DateTime.fromISO(entity[key]).toString();
						if (hostKey3 !== null) request[hostKey1][hostKey2][hostKey3][formKey] = date;
						if (hostKey2 !== null) request[hostKey1][hostKey2][formKey] = date;
						else if (hostKey1 !== null) request[hostKey1][formKey] = date;
						else {
							request[formKey] = date;
						}
					}
				} else if (formKey !== 'id') {
					if (hostKey3 != null) {
						if (hostKey3 !== 'id') {
							request[hostKey1][hostKey2][hostKey3][formKey] = entity[key];
						}
					}
					else if (hostKey2 != null) {
						if (hostKey2 !== 'id') {
							request[hostKey1][hostKey2][formKey] = entity[key];
						}
					} else if (hostKey1 != null) {
						request[hostKey1][formKey] = entity[key];
					} else {
						request[formKey] = entity[key];
					}
				}
			}
		}
	});

    return this.http.patch<Object>(this.getHost(host) + '/' + subRoute + '/' + entity['id'], request);
  }

  // delete entity

  deleteEntity(host: string, subRoute: string, entity: Object) {
    return this.http.delete<Object>(this.getHost(host) + '/' + subRoute + '/' + entity['id']);
  }

  deleteGeneratedData(companyId: string) {
	  return this.http.delete(ADMINISTRATION + '/companies/' + companyId + '/generateddata');
  }

  downloadCompanyFile(companyId: string, filename: string): Observable<any> {
	let headers = new HttpHeaders();
	headers = headers.set('Accept', 'application/pdf');
	headers = headers.set('Authorization', this.authService.authorizationHeader);
	return this.httpClient.get(ADMINISTRATION + '/companies/' + companyId + '/downloadfile?filename=' + filename, { headers: headers, responseType: 'blob' });
  }

  private getHost(prefix: string) {
	if (prefix == 'administration') return ADMINISTRATION;
	else if (prefix == 'import') return IMPORT;
	else if (prefix == 'datacenter') return DATACENTER;
	else if (prefix == 'inspection') return INSPECTION;
	return HOST;
  }

  private getSubRoute(subRoute: string) {
	var res = subRoute.toLowerCase();
	if (res.slice(-1) === 's') return res;
	if (res.slice(-1) === 'y') {
		return res.slice(0, -1) + 'ies';
	}
	return res + 's';
  }
}
